// extracted by mini-css-extract-plugin
export default {"whySection":"WhySection_whySection__DUtnq","whySectionTitle":"WhySection_whySectionTitle__dvh4t","title":"WhySection_title__AueYC","paragraph":"WhySection_paragraph__NA-ug"};